const cadastro_de_informacao_complementar = [
  {
    path: "/cadastro-de-informacao-complementar",
    redirect: "/cadastro_de_informacao_complementar",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/cadastro-de-informacao-complementar",
        name: "cadastro_de_informacao_complementar",
        component: () =>
          import(
            "@/views/CadastroDeInformacaoComplementar/CadastroDeInformacaoComplementarHome.vue"
          ),
      },
      {
        path: "/cadastro-de-informacao-complementar/novo",
        name: "cadastro_de_informacao_complementar_novo",
        component: () =>
          import(
            "@/views/CadastroDeInformacaoComplementar/CadastroDeInformacaoComplementarCadastro.vue"
          ),
      },
      {
        path: "/cadastro-de-informacao-complementar/:id",
        name: "cadastro_de_informacao_complementar_editar",
        component: () =>
          import(
            "@/views/CadastroDeInformacaoComplementar/CadastroDeInformacaoComplementarEditar.vue"
          ),
      },
    ],
  },
];

export { cadastro_de_informacao_complementar };
